import USER_ACTIONS from "./user";
import ANALYSIS_ACTIONS from "./analysis";
import JOB_TYPE_ACTIONS from "./jobType";
import LOGIN_ACTIONS from "./login";
import SHIFT_ACTION from "./shift";
import APP_ACTIONS from "./app";
import BRANCH_ACTIONS from "./branch";
import CALENDAR_ACTIONS from "./calendar";
import CHECK_TIME_ACTIONS from "./checkTime.js";
import DAILY_REPORT_ACTIONS from "./dailyReport.js";
import LEAVE_HISTORY_ACTIONS from "./leaveHistory.js";
import LEAVE_TYPE_ACTIONS from "./leaveType";
import NOTIFICATION_ACTIONS from "./notification";
import PAYROLL_ACTIONS from "./payroll";
import SALARY_ACTIONS from "./salary";
import SETTING_ACTIONS from "./setting";
import STATUS_ACTIONS from "./status";
import USER_FACE_ACTIONS from "./userFace";
import USER_SHIFT_TYPE_ACTION from "./userShiftType";
import GENERAL_SETTING_ACTION from "./generalSetting";
import DAILY_RATING_ACTIONS from "./dailyRating";
import { FORM_CREATE_REASON } from "../createReasonConstants";
import { POPUP_DELETE_REASON } from "../deleteReasonConstants";
import META_DATA_ACTIONS from "./metaDataOrg";

const ACTIONS = {
  ...USER_ACTIONS,
  ...ANALYSIS_ACTIONS,
  ...JOB_TYPE_ACTIONS,
  ...LOGIN_ACTIONS,
  ...SHIFT_ACTION,
  ...APP_ACTIONS,
  ...BRANCH_ACTIONS,
  ...CALENDAR_ACTIONS,
  ...CHECK_TIME_ACTIONS,
  ...DAILY_REPORT_ACTIONS,
  ...LEAVE_HISTORY_ACTIONS,
  ...LEAVE_TYPE_ACTIONS,
  ...NOTIFICATION_ACTIONS,
  ...PAYROLL_ACTIONS,
  ...SALARY_ACTIONS,
  ...SETTING_ACTIONS,
  ...STATUS_ACTIONS,
  ...USER_FACE_ACTIONS,
  ...USER_SHIFT_TYPE_ACTION,
  ...GENERAL_SETTING_ACTION,
  ...DAILY_RATING_ACTIONS,
  ...FORM_CREATE_REASON,
  ...POPUP_DELETE_REASON,
  ...META_DATA_ACTIONS,
};
export default ACTIONS;
